import { render, staticRenderFns } from "./StudentApplicationForm.vue?vue&type=template&id=ac21b730&scoped=true"
import script from "./StudentApplicationForm.vue?vue&type=script&lang=ts"
export * from "./StudentApplicationForm.vue?vue&type=script&lang=ts"
import style0 from "./StudentApplicationForm.vue?vue&type=style&index=0&id=ac21b730&prod&lang=scss&scoped=true"
import style1 from "./StudentApplicationForm.vue?vue&type=style&index=1&id=ac21b730&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac21b730",
  null
  
)

export default component.exports